import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouterModule } from "@angular/router";
import { CommonTranslateModule } from "src/app/shared/utils/common-translate.module";
import { HomePageComponent } from "./home-page.component";
import { NavigationModule } from "src/app/shared/components/navigation/navigation.module";
import { IconsModule } from "src/app/shared/icons.module";
@NgModule({
  declarations: [HomePageComponent],
  providers: [],
  imports: [CommonModule, RouterModule, CommonTranslateModule, BrowserAnimationsModule, IconsModule, NavigationModule],
})
export class HomePageModule {}
